<template>
  <div class="content col-md-12">
    <p v-if="loading">{{ $t('message.loading') }}</p>
    <div
      v-else
      class="col-md-12 no-padding">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['loading'],
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseContent.vue